import {CHOOSE_LANGUAGE} from "../constants/actionTypes";

export const chooseLanguageAction = (locale) => ({
    type: CHOOSE_LANGUAGE,
    locale : locale
});